import Container from 'react-bootstrap/Container';
import * as React from 'react';
import {Col} from 'react-bootstrap';
import {HeadTitle} from './HeadTitle';

export const MenuItemContainer = ({title, children}) => {
  return (
    <div style={{flexGrow: 1}}>
      <Col style={{padding: '20px'}}>
        <HeadTitle title={title} />
        {children}
      </Col>
    </div>
  );
};
